"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Class representing rounding rule
 *
 * @author RV
 */


var RoundingRule =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(RoundingRule, _DomainObject_1$Domai);

  /**
   *
   * @param id
   * @param roundingStep rounding numbers by this value (usually 0.50, 0.90)
   * @param startingAt minimal value of interval when rule will be used (max interval is minimal of next rule)
   * @param threshold1 threshold for prices rounded on ones
   * @param threshold10 threshold for prices rounded on tens
   * @param useBataPrice1 flag whether we want use bata price on ones
   * @param useBataPrice10 flag whether we want use bata price on tens
   * @param decrease1 value by which we want decrease price for ones
   * @param decrease10 value by which we want decrease price for tens
   * @param weighted flag for mark weighted products
   */
  function RoundingRule(id, roundingStep, startingAt, threshold1, threshold10, useBataPrice1, useBataPrice10, decrease1, decrease10, weighted) {
    var _this;

    _classCallCheck(this, RoundingRule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundingRule).call(this));
    _this.id = id;
    _this.roundingStep = roundingStep;
    _this.startingAt = startingAt;
    _this.threshold1 = threshold1;
    _this.threshold10 = threshold10;
    _this.useBataPrice1 = useBataPrice1;
    _this.useBataPrice10 = useBataPrice10;
    _this.decrease1 = decrease1;
    _this.decrease10 = decrease10;
    _this.weighted = weighted;
    return _this;
  }

  return RoundingRule;
}(DomainObject_1.DomainObject);

exports.RoundingRule = RoundingRule;

RoundingRule.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RoundingRule.name);
  return {
    id: builder.str('id'),
    roundingStep: builder.bigNum('roundingStep'),
    startingAt: builder.bigNum('startingAt'),
    threshold1: builder.opt(builder.bigNum('threshold1')),
    threshold10: builder.opt(builder.bigNum('threshold10')),
    useBataPrice1: builder.bool('useBataPrice1'),
    useBataPrice10: builder.bool('useBataPrice10'),
    decrease1: builder.opt(builder.bigNum('decrease1')),
    decrease10: builder.opt(builder.bigNum('decrease10')),
    weighted: builder.bool('weighted')
  };
}();